import React from "react";
import "./AdminDashboardHome.css";
import useCountUp from "../../hooks/useCountUp";

function formatValue(value) {
  if (value === null || value === undefined) return "N/A";
  return typeof value === "number" ? value.toLocaleString("en-IN") : value;
}

// Purpose-built KPI card for the Admin Home landing page — deliberately
// NOT the shared <MetricCard/> (used by Organization/Team/Project
// dashboards) so this landing page reads as its own surface instead of
// looking identical to those detailed report pages. No "Higher/Lower is
// better" hint line here: that reads as a glanceable summary tile, not a
// metrics report.
// Dynamic Forms visibility audit, §8: `onClick` is optional and additive --
// a card that doesn't pass one renders exactly as before (a plain `div`,
// not a button, so every existing caller is unaffected). Cards should not
// be dead numbers when they have a real drill-down destination.
export default function StatCard({ icon, label, value, subtext, accent = "info", onClick }) {
  const isEmpty = value === null || value === undefined;
  const Tag = onClick ? "button" : "div";
  const displayValue = useCountUp(value);

  return (
    <Tag
      type={onClick ? "button" : undefined}
      className={`adh-stat-card adh-stat-${accent}${isEmpty ? " adh-stat-empty" : ""}${onClick ? " adh-stat-clickable" : ""}`}
      onClick={onClick}
    >
      <span className="adh-stat-icon">
        <i className={`fa-solid ${icon}`} aria-hidden="true"></i>
      </span>
      <span className="adh-stat-body">
        <span className="adh-stat-label">{label}</span>
        <span className="adh-stat-value">{formatValue(displayValue)}</span>
        {subtext && <span className="adh-stat-subtext">{subtext}</span>}
      </span>
    </Tag>
  );
}
